<template>
  <div class="flex items-start justify-center text-4xl font-bold leading-tight">
    <div class="text-center w-20">
      <p class="leading-none">
        {{ hours | twoDigits }}
      </p>
      <p class="uppercase font-bold text-gray-600 text-xs">
        {{ hours > 1 ? 'hours' : 'hour' }}
      </p>
    </div>
    <div class="leading-none">
      :
    </div>
    <div class="text-center w-20">
      <p class="leading-none">
        {{ minutes | twoDigits }}
      </p>
      <p class="uppercase font-bold text-gray-600 text-xs">
        min
      </p>
    </div>
    <div class="leading-none">
      :
    </div>
    <div class="text-center w-20">
      <p class="leading-none">
        {{ seconds | twoDigits }}
      </p>
      <p class="uppercase font-bold text-gray-600 text-xs">
        Sec
      </p>
    </div>
  </div>
</template>

<script>
let interval = null

export default {
    name: "VuejsCountDown",
    props: {
        deadline: {
            type: String,
            default: null
        },
        end: {
            type: String,
            default: null
        },
        stop: {
            type: Boolean
        }
    },
    data() {
        return {
            now: Math.trunc((new Date()).getTime() / 1000),
            date: null,
            diff: 0
        }
    },
    created() {
        if (!this.deadline && !this.end) {
            throw new Error("Missing props 'deadline' or 'end'")
        }

        let endTime = this.deadline ? this.deadline : this.end
        this.date = Math.trunc(Date.parse(endTime.replace(/-/g, "/")) / 1000)

        if (!this.date) {
            throw new Error("Invalid props value, correct the 'deadline' or 'end'")
        }

        interval = setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000)
        }, 1000)
    },
    computed: {
        seconds() {
            return Math.trunc(this.diff) % 60
        },

        minutes() {
            return Math.trunc(this.diff / 60) % 60
        },

        hours() {
            return Math.trunc(this.diff / 60 / 60)
        }
    },
    watch: {
        now() {
            this.diff = this.date - this.now
            if(this.diff <= 0 || this.stop){
                this.diff = 0
                // Remove interval
                clearInterval(interval)
            }
        }
    },
    filters: {
        twoDigits(value) {
            if ( value.toString().length <= 1 ) {
                return "0"+value.toString()
            }
            return value.toString()
        }
    },
    destroyed() {
        clearInterval(interval)
    }
}
</script>
